var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card-text",
    [
      _c(
        "v-timeline",
        { attrs: { "align-top": "", dense: "" } },
        [
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _vm.showCameraNavigateMode
                ? _c(
                    "v-row",
                    { staticClass: "pt-1" },
                    [
                      _c("v-col", [
                        _c("span", { staticClass: "subtitle-1" }, [
                          _vm._v("Touch tapping"),
                        ]),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Touch mode may require triple tapping as double tap isn't detected reliably yet"
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", [
                    _c("span", { staticClass: "subtitle-1" }, [
                      _vm._v(
                        _vm._s(
                          _vm.showCameraNavigateMode
                            ? "Camera navigation"
                            : "View navigation"
                        )
                      ),
                    ]),
                    _vm.showCameraNavigateMode
                      ? _c("div", [
                          _c("ul", { staticClass: "icon-list" }, [
                            _c("li", [
                              _vm._v(
                                "Double tap to reframe the character or body section"
                              ),
                            ]),
                            _c(
                              "li",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mx-4",
                                    attrs: {
                                      outlined: "",
                                      fab: "",
                                      small: "",
                                      color: "accent",
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("$panCamera")])],
                                  1
                                ),
                                _vm._v(
                                  "moves the scene in the direction of drag."
                                ),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mx-4",
                                    attrs: {
                                      outlined: "",
                                      fab: "",
                                      small: "",
                                      color: "accent",
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("$fpsCamera")])],
                                  1
                                ),
                                _vm._v(
                                  "moves the camera like FPS mode. Dragging up moves forward."
                                ),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mx-4",
                                    attrs: {
                                      outlined: "",
                                      fab: "",
                                      small: "",
                                      color: "accent",
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("$rotateCamera")])],
                                  1
                                ),
                                _vm._v(
                                  "rotates the camera around a focal point."
                                ),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mx-4",
                                    attrs: {
                                      outlined: "",
                                      fab: "",
                                      small: "",
                                      color: "accent",
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("$zoomCamera")])],
                                  1
                                ),
                                _vm._v("zooms the camera in and out."),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mx-4",
                                    attrs: {
                                      outlined: "",
                                      fab: "",
                                      small: "",
                                      color: "accent",
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("$exitCamera")])],
                                  1
                                ),
                                _vm._v(
                                  "exits camera nagivation to normal operation."
                                ),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _c("ul", [
                          _c("li", [_vm._v("Rotate with alt+drag")]),
                          _c("li", [_vm._v("Pan with middle mouse+drag")]),
                          _c("li", [_vm._v("Zoom with middle mouse scroll")]),
                          _c("li", [
                            _vm._v("First person navigation with WASD+QE keys"),
                          ]),
                          _c("li", [
                            _vm._v(
                              "F key reframes the character or body section"
                            ),
                          ]),
                        ]),
                  ]),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", [
                    _c("span", { staticClass: "subtitle-1" }, [
                      _vm._v("Modeling section tuning"),
                    ]),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "Double click on the head, neck, body, legs, or feet to tune the section"
                        ),
                      ]),
                      _c("li", [
                        _vm._v(
                          "U key while tuning a body section backs up to character level"
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", [
                    _c("span", { staticClass: "subtitle-1" }, [
                      _vm._v("Pose section tuning"),
                    ]),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          "Double click in an empty area to hide secondary controls"
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-4",
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                          },
                        },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.mdiEyeOutline))])],
                        1
                      ),
                      _vm._v("previews the asset file"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-4",
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                          },
                        },
                        [_c("v-icon", [_vm._v("share")])],
                        1
                      ),
                      _vm._v("copies a link for sharing"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-4",
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                          },
                        },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.mdiRestore))])],
                        1
                      ),
                      _vm._v("resets the character build or pose"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }